import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  Edit,
  Delete,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import MuiAlert from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  table: {
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  buttonCol: {
    textAlign: "center",
    width: "170px",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  colorBox: {
    display: "inline-block",
    width: "12px",
    height: "12px",
    marginRight: "5px",
  },
}));

function Types(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [types, setTypes] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [deleteTypes, setDeleteTypes] = React.useState("");
  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(null);


  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - メディア管理";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess(true);
      setSuccessMessage("登録が完了しました");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess(true);
      setSuccessMessage("更新が完了しました");
    }
    if (props.location.search.indexOf("delete") > -1) {
      setSuccess(true);
      setSuccessMessage("削除が完了しました");
    }
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchTypes();
  }, [auth.state.token]);

  const fetchTypes = () => {
    request({
      method: "GET",
      url: `admin/media/types`,
    }).then((result) => {
      setTypes(result.data.data);
    });
  };

  const onClickEditButton = (typeId) => {
    props.history.push(`/admin/media/types/edit/${typeId}`);
  };

  const openDialog = (id, index) => {
    setDeleteId(id);
    setIsShowModal(true);
    const sources = types[index-1].sources;
    let dialogText = [];
    for (let index = 0; index < sources.length; index++) {
      dialogText.push(sources[index])
        if (index == 2) {
          if (sources.length > 2) {
            setDeleteTypes(dialogText.join(" , ") + " , etc.");
          } else {
            setDeleteTypes(dialogText.join(" , "));
          }
          break;
        }
        setDeleteTypes(dialogText.join(" , "));
    }
  };

  const clearDialog = () => {
    setIsShowModal(false);
    setDeleteId(0);
    setDeleteTypes("");
  }

  const deleteType = () => {
    request({
      method: "DELETE",
      url: `admin/media/types/${deleteId}`,
    }).then(() => {
      fetchTypes();
      setIsShowModal(false);
    });
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{row.id}</TableCell>
          <TableCell><span className={classes.colorBox} style={{backgroundColor:row.color}}></span>{row.label}</TableCell>
          <TableCell className={classes.buttonCol}>
            <IconButton 
              color="primary" 
              aria-label="add an Edit"
              onClick={() => onClickEditButton(row.id)}
            >
              <Edit />
            </IconButton>
            <IconButton 
              className={classes.buttonRed} 
              aria-label="add an Delete"
              onClick={() => openDialog(row.id, index)}
            >
              <Delete />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                メディア一覧
              </Typography>
              <Table className={classes.table} data-testid="mediaTypesList-table">
                <TableHead>
                  <TableRow>
                    <TableCell>メディアID</TableCell>
                    <TableCell>メディア名</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {types.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {successMessage}
              </MuiAlert>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                data-testid="mediaTypesList-createButton"
                onClick={() => props.history.push(`/admin/media/types/create`)}
              >
                新規登録
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => clearDialog()} data-testid="mediaTypesList-deleteDialog">
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
              <DialogContentText>
                選択されたメディアには以下のキーワードが含まれます。
              </DialogContentText>
              <DialogContentText>
                {deleteTypes}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" data-testid="mediaTypesList-deleteConfirmButton" onClick={deleteType}>
                はい
              </Button>
              <Button color="primary" data-testid="mediaTypesList-deleteCancelButton" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Types);
